import { container, AssetManager, InstructionSlide, InfoPopup, device } from '@game-studio/arcade-base';

import { IGameStrings, ISkinConfigEx } from '@/src/types';

/**
 * Extending the cutomizable InfoPopup Component
 * ToDo: Replace/configure example slides to match game designs
 * - See the wiki for config details
 * - https://github.com/tombolaltd/arcade-client-monorepo/blob/master/packages/base-package/wiki/info-popup/info-popup.md
 */
export class HowToPlay extends InfoPopup {
    constructor() {
        // fontStyles loaded from skin config for different skin visuals
        const config = (container.skin.config as ISkinConfigEx).howToPlay.slide;
        const fontStyles = {
            default: config.defaultTextStyle,
            bullet: config.bulletTextStyle,
            title: config.titleTextStyle
        };

        // Three example slides using the built in InstructionSlide
        const htpTexture1 = AssetManager.getTextureResourceData('htp-first-screen');
        const htpTexture2 = AssetManager.getTextureResourceData('htp-second-screen');
        const htpTexture3 = AssetManager.getTextureResourceData('htp-third-screen');
        const htpTexture4 = AssetManager.getTextureResourceData('htp-forth-screen');
        const htpSlideStrings = (container.strings as IGameStrings).howToPlay.slides;
        const htpSlides = [
            new InstructionSlide(htpTexture1, htpSlideStrings[0], {
                fontStyles, // uses pixi default (small black text)
                imageWidth: 0.5, // defaults to 0.5
                textPadding: {
                    // paddings default to 0
                    top: 0.15,
                    left: 0.075,
                    right: 0.0
                }
            }),
            new InstructionSlide(htpTexture2, htpSlideStrings[1], {
                fontStyles, // uses pixi default (small black text)
                imageWidth: 0.5, // defaults to 0.5
                textPadding: {
                    // paddings default to 0
                    top: 0.12,
                    left: 0.075,
                    right: 0.0
                }
            }),
            new InstructionSlide(htpTexture3, htpSlideStrings[2], {
                fontStyles, // uses pixi default (small black text)
                imageWidth: 0.5, // defaults to 0.5
                textPadding: {
                    // paddings default to 0
                    top: 0.1,
                    left: 0.075,
                    right: 0.0
                }
            }),
            new InstructionSlide(htpTexture4, htpSlideStrings[3], {
                fontStyles, // uses pixi default (small black text)
                imageWidth: 0.5, // defaults to 0.5
                textPadding: {
                    // paddings default to 0
                    top: 0.16,
                    left: 0.075,
                    right: 0.0
                }
            })
        ];

        super(
            device,
            htpSlides,
            {
                background: AssetManager.getTextureResourceData('htp-background'),
                arrow: AssetManager.getTextureResourceData('htp-arrow'),
                close: AssetManager.getTextureResourceData('htp-close-btn')
            },
            {
                // optional config options to tweak appearance
                xPadding: 0,
                arrowScale: 1,
                arrowXOffset: -50,
                slideWidthMultiplier: 0.75,
                slideHeightMultiplier: 0.575,
                slideYOffsetMultiplier: 0.08,
                slideXOffsetMultiplier: 0
            }
        );
    }
}
